import { inject, Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { iif, Observable, switchMap } from 'rxjs'
import { environment } from '@env'
import { CoreAuthService } from '@core/auth/services/core-auth-service'
import { take } from 'rxjs/operators'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { TokenResponse } from '@openid/appauth'

const AUTH_DOMAINS = [environment.api.apiDomain]

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  private readonly _ionicAuth: CoreAuthService = inject(CoreAuthService)

  private _handleTokenizedRequest(request: HttpRequest<any>, next: HttpHandler) {
    return this._ionicAuth.token$.pipe(
      takeUntilDestroyed(),
      take(1),
      switchMap((resp: TokenResponse) =>
        next.handle(
          resp?.accessToken
            ? request.clone({
                setHeaders: {
                  'Content-Type': 'application/json',
                  Authorization: `${environment.tokenType} ${resp.accessToken}`
                }
              })
            : request
        )
      )
    )
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return iif(
      () => AUTH_DOMAINS.some((domain) => request.url.indexOf(domain) === 0),
      this._handleTokenizedRequest(request, next),
      next.handle(request)
    )
  }
}
